import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PolarChartService } from './polar-chart.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: "app-polar-chart",
  templateUrl: "./polar-chart.component.html",
  styleUrls: ["./polar-chart.component.scss"],
})
export class PolarChartComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private polarChartService: PolarChartService,
    public spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  @ViewChild("mdOptionsGrap") mdOptionsGrap: ModalDirective;
  @Input() listColumn = [];
  @Input() queryId: string;
  @Input() basedOnId: string;
  @Input() queryConfigType: string;
  @Input() selectTypeGraphic;
  @Input() arguments = [];
  @Output() onVewGraphic: EventEmitter<any> = new EventEmitter<any>();
  registerPolarForm: FormGroup;
  controls: any;
  submitted = false;
  dataGraphic: any = {};
  objectGraphic: any = {};
  msgSpiner = 'Cargando...';
  positionList = [
    { name: "right", title: "Derecha" },
    { name: "left", title: "Izquierda" },
    { name: "top", title: "Arriba" },
    { name: "bottom", title: "Abajo" },
  ];

  polartypegrafic = [
    { name: "Monochrome", title: "Monochrome Polar" },
    { name: "Simple", title: "Simple Polar" },
  ];

  message = {
    message: null,
    class: null,
  };

  //Variable temporal
  objectFinal2 = {
    series: [76, 67, 61, 90],
    chart: {
      background: "",
      height: 700,
      width: 700,
      type: "polarArea",
      position: "right",
      offsetX: 90,
      offsetY: 20,
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ",",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: "zoom",
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "30%",
          background: "transparent",
          image: undefined,
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
      },
    },
    title: {
      text: "Polar Chart",
    },
    colors: ["#5499C7", "#5499C7", "#2471A3", "#1F618D", "#1A5276", "#154360"],
    labels: ["Vimeo", "Messenger", "Facebook", "LinkedIn"],
    legend: {
      show: true,
      floating: false,
      fontSize: "12px",
      position: "left",
      offsetX: 0,
      offsetY: 10,
      labels: {
        useSeriesColors: true,
      },
      formatter: function (seriesName, opts) {
        return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
      },
      itemMargin: {
        horizontal: 3,
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  //Variable temporal

  objectFinal = {
    series: [],
    chart: {
      background: "",
      height: 700,
      width: 700,
      type: "polarArea",
      position: "right",
      offsetX: 90,
      offsetY: 20,
      toolbar: {
        show: true,
        offsetX: -23,
        offsetY: 19,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ",",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: "zoom",
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "30%",
          background: "transparent",
          image: undefined,
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
      },
    },
    title: {
      text: "Polar Chart",
    },

    labels: [],
    legend: {
      show: true,
      floating: false,
      fontSize: "12px",
      position: "left",
      offsetX: 0,
      offsetY: 10,
      labels: {
        useSeriesColors: true,
      },
      formatter: function (seriesName, opts) {
        return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
      },
      itemMargin: {
        horizontal: 3,
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  ngOnInit() {
    this.registerPolarForm = this.formBuilder.group({
      polartypegrafic: [
        { name: "Simple", title: "Simple Polar" },
        [Validators.required],
      ],
      column: [null, [Validators.required]],
      value: [null, [Validators.required]],
      color: ["transparent", [Validators.required]],
      position: [{ name: "bottom", title: "Abajo" }, [Validators.required]],
      title: ["Titlo de ejemplo", [Validators.required]],
    });
    this.controls = this.registerPolarForm.controls;
  }

  selectshowgrafic() {
    if (
      this.registerPolarForm.controls.polartypegrafic.value.name == "Simple"
    ) {
      this.showGraphicsimple();
    }
    if (
      this.registerPolarForm.controls.polartypegrafic.value.name == "Monochrome"
    ) {
      this.showGraphic2monocromatic();
    }
  }

  showGraphic2monocromatic() {
    this.spinner.show()
    console.log("mono entro");
    this.submitted = true;
    console.log(this.controls);

    if (this.registerPolarForm.invalid) {
      this.message = {
        message: "Todos los campos son obligatorios",
        class: "alert alert-danger mt-2",
      };
      setTimeout(() => {
        this.message = {
          message: null,
          class: null,
        };
      }, 3000);
    }

    this.objectFinal2.chart.toolbar.export.png.filename =
      this.objectFinal2.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.objectFinal2.chart.toolbar.export.svg.filename =
      this.objectFinal2.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.objectFinal2.chart.toolbar.export.csv.filename =
      this.objectFinal2.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");

    this.objectFinal2.legend.position =
      this.registerPolarForm.controls.position.value.name;
    this.objectFinal2.title.text = this.registerPolarForm.controls.title.value;
    this.objectFinal2.chart.background =
      this.registerPolarForm.controls.color.value;
    //this.objectFinal.chart.fontFamily = this.registerPolarForm.controls.font.value.name;

    //Peticion del grafico
    
    this.polarChartService
      .onGetDataGraphic(
        this.queryId,
        this.basedOnId,
        this.arguments,
        this.queryConfigType
      )
      .subscribe((res: any) => {
        this.objectGraphic = this.getDataGrafic(res);
        this.objectFinal2.series = this.objectGraphic.series;
        this.objectFinal2.labels = this.objectGraphic.labels;
        //Se emitirá al componente contenedor el objeto grafico, para posteriormente visializarlo
        this.onVewGraphic.emit(this.objectFinal2);
      }, err => {
        this.toastr.error('Error consulta de datos del grafico Polar: ' +  err);
        this.spinner.hide();
        console.log('Error consulta de dtos del grafico Polar: ', err);
      });
      this.spinner.hide();
  }

  showGraphicsimple() {
    this.spinner.show()
    this.submitted = true;

    if (this.registerPolarForm.invalid) {
      this.message = {
        message: "Todos los campos son obligatorios",
        class: "alert alert-danger mt-2",
      };
      setTimeout(() => {
        this.message = {
          message: null,
          class: null,
        };
      }, 3000);
    }

    this.objectFinal.chart.toolbar.export.png.filename =
      this.objectFinal.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.objectFinal.chart.toolbar.export.svg.filename =
      this.objectFinal.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.objectFinal.chart.toolbar.export.csv.filename =
      this.objectFinal.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");

    this.objectFinal.legend.position =
      this.registerPolarForm.controls.position.value.name;
    this.objectFinal.title.text = this.registerPolarForm.controls.title.value;
    this.objectFinal.chart.background =
      this.registerPolarForm.controls.color.value;
    //this.objectFinal.theme.monochrome.enabled =this.registerPolarForm.controls.pietypegrafic.value.name;

    //this.objectFinal.chart.fontFamily = this.registerPolarForm.controls.font.value.name;
    // this.objectFinal.chart.fontSize =
    //   this.registerPieForm.controls.fontSize.value;

    //Peticion del grafico
    this.spinner.show()
    this.polarChartService
      .onGetDataGraphic(
        this.queryId,
        this.basedOnId,
        this.arguments,
        this.queryConfigType
      )
      .subscribe((res: any) => {
        this.objectGraphic = this.getDataGrafic(res);
        this.objectFinal.series = this.objectGraphic.series;
        this.objectFinal.labels = this.objectGraphic.labels;
        //Se emitirá al componente contenedor el objeto grafico, para posteriormente visializarlo
        this.onVewGraphic.emit(this.objectFinal);
      }, err => {
        this.toastr.error('Error consulta de datos del grafico Polar: ' +  err);
        this.spinner.hide();
        console.log('Error consulta de dtos del grafico Polar: ', err);
      });
      this.spinner.hide();
  }

  getDataGrafic(restultGrid) {
    let ListDataGrid = restultGrid.data;
    let object: any = {};
    object.labels = [];
    object.series = [];

    ListDataGrid.forEach((dataGrid) => {
      object.labels.push(
        dataGrid[this.registerPolarForm.controls.column.value.field]
      );
      object.series.push(
        dataGrid[this.registerPolarForm.controls.value.value.field]
      );
    });
    return object;
  }
}
